import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent, Typography, Grid, Hidden } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import SearchHeader from "./view/_search-header";
import SearchContent from "./view/_search-content";
import axios from "axios";
import { store } from "../../../helpers/store";
import { useDispatch, useSelector } from "react-redux";
import { config } from "../../../enviroment";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "70px",
  },
  stacktop: {
    position: "absolute",
    top: "20%",
    right: "7%",
    left: "7%",
    borderRadius: "12px",
  },
  quinaryBackground: {
    background: theme.palette.quinary.main + "!important",
    width: "-webkit-fill-available !important",
    position: "absolute",
    height: "-webkit-fill-available !important",
    height: "110% !important",
  },
  primaryBackground: {
    background: theme.palette.ePrimary.base + " !important",
    width: "-webkit-fill-available !important",
    minHeight: "30vh",
  },
  search: {
    padding: "2%",
  },
}));

export default function Search() {
  const classes = useStyles();
  const isTabletOrMobile = useMediaQuery({ query: "(min-width: 960px)" });
  const smQuery = useMediaQuery({ query: "(min-width: 780px)" });
  const [searchResults, setsearchResults] = useState({});
  const [sloading, setsLoading] = useState(true);
  const keyword = useSelector((state) => state.searchResults.keyword);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const submitHandlesearch = (word) => {
    if (keyword || word) {
      setsLoading(true);
      axios
        .post(config.urls.SEARCH, {
          size: 50,
          query: {
            multi_match: {
              query: `*${word ? word : keyword}*`,
              fuzziness: "AUTO",
              fields: ["ContentTitle", "ContentCategoryCode", "ContentValue"],
            },
          },
        })
        .then((res) => {
          setsearchResults(res.data);
          setsLoading(false);
          store.getState().snackbar = false;
        })
        .catch((error) => {
          store.getState().snackbar = false;
          setsLoading(false);
        });
    }
  };

  useEffect(() => {
    submitHandlesearch();
  }, []);

  return (
    <div className={classes.root}>
      <React.Fragment>
        {isTabletOrMobile ? (
          <React.Fragment>
            <Grid container direction="column">
              <Grid item>
                <div className={classes.primaryBackground} />
              </Grid>
              <Grid item>
                <div className={classes.quinaryBackground} />
              </Grid>
            </Grid>
            <Card className={classes.stacktop}>
              <CardContent>
                <SearchHeader
                  submitHandlesearch1={(word) => submitHandlesearch(word)}
                />
                <hr />
                <SearchContent
                  submitHandlesearch={submitHandlesearch}
                  sloading={sloading}
                  searchResults={searchResults}
                />
              </CardContent>
            </Card>
          </React.Fragment>
        ) : (
          <div className={classes.search}>
            <SearchHeader
              submitHandlesearch1={(word) => submitHandlesearch(word)}
            />
            <hr />
            <SearchContent
              sloading={sloading}
              submitHandlesearch={submitHandlesearch}
              searchResults={searchResults}
            />
          </div>
        )}
      </React.Fragment>
    </div>
  );
}
